module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Bold.52d71683.woff2";